<div if.bind="account.profileOpen" class="modal-overlay">
  <form class="login-modal profile-modal" submit.trigger="account.saveNotificationPreferences()" click.trigger="$event.stopPropagation()">
    <h3 class="login-modal__title">Notification settings</h3>
    <p class="profile-modal__subtitle">Choose which emails Toy Calendar sends to ${account.userEmail}.</p>

    <label class="profile-toggle">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Daily digest</span>
        <span class="profile-toggle__hint">A summary of releases added in the last 24 hours.</span>
      </span>
      <input type="checkbox" class="profile-toggle__input" checked.bind="account.notificationPreferences.digestOptIn" disabled.bind="account.savingPreferences" />
    </label>

    <label class="profile-toggle">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Saved-search alerts</span>
        <span class="profile-toggle__hint">Email me when new releases match a saved search I follow.</span>
      </span>
      <input type="checkbox" class="profile-toggle__input" checked.bind="account.notificationPreferences.notifySavedSearches" disabled.bind="account.savingPreferences" />
    </label>

    <label class="profile-toggle profile-toggle--select" if.bind="account.notificationPreferences.notifySavedSearches">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Saved-search frequency</span>
        <span class="profile-toggle__hint">How often to email saved-search matches.</span>
      </span>
      <select class="profile-select" value.bind="account.notificationPreferences.savedSearchFrequency" disabled.bind="account.savingPreferences">
        <option value="daily">Once per day</option>
        <option value="every-update">Every update</option>
      </select>
    </label>

    <label class="profile-toggle">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Availability alerts</span>
        <span class="profile-toggle__hint">Email me when a release I follow becomes available.</span>
      </span>
      <input type="checkbox" class="profile-toggle__input" checked.bind="account.notificationPreferences.notifyAvailability" disabled.bind="account.savingPreferences" />
    </label>

    <p class="profile-modal__note">Turning a master switch off silences its per-item bells without removing them.</p>
    <div if.bind="account.profileError" class="login-error">${account.profileError}</div>
    <div class="login-actions">
      <button type="button" class="login-btn login-btn--secondary" click.trigger="account.closeProfile()" disabled.bind="account.savingPreferences">Cancel</button>
      <button type="submit" class="login-btn login-btn--primary" disabled.bind="account.savingPreferences">
        ${account.savingPreferences ? 'Saving…' : 'Save'}
      </button>
    </div>
  </form>
</div>
